import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import HalcyonLogoContainer from "../halcyon/sub-components/HalcyonLogoContainer";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    height: "250vh",
    position: "relative",
  },
  videoContainer: {
    position: "sticky",
    top: 0,
    height: "150vh",
    width: "100%",
    overflow: "hidden",
    zIndex: 1,
    [theme.breakpoints.down("xs")]: {
      height: "100vh",
    },
    [theme.breakpoints.only("sm")]: {
      height: "110vh",
      margin: "0rem 0rem 2.5rem 0rem",
    },
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "150vh",
    objectFit: "cover",
    zIndex: -1,
    [theme.breakpoints.down("xs")]: {
      height: "100vh",
      objectFit: "cover",
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      height: "110vh",
      objectFit: "cover",
      width: "100%",
    },
  },
  imageOverlay: {
    position: "absolute",
    left: 0,
    width: "100%",
    height: "150vh",
    objectFit: "cover",
    zIndex: 2,
    transition: "transform 0.3s ease-out",
    [theme.breakpoints.only("xs")]: {
      height: "100vh",
      objectFit: "cover",
      //   top: "20%",
      width: "370px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "100vh",
      objectFit: "cover",
      width: "512px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "120vh",
      objectFit: "cover",
      width: "100%",
      padding: "0rem 1rem 0rem 0rem",
    },
  },
  logoContainer: {
    position: "absolute",
    top: "15%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 3,
    transition: "opacity 0.3s ease-out",
    [theme.breakpoints.only("sm")]: {
      top: "20%",
    },
  },
}));

const SectionOne = () => {
  const classes = useStyles();
  const [scrollY, setScrollY] = useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const buildingTranslateY = Math.max(0, 100 - scrollY * 0.25);

  // Calculate logo opacity fade between 200px and 400px scroll
  const fadeStart = 200;
  const fadeEnd = 400;
  const logoOpacity =
    scrollY < fadeStart ? 1 : scrollY > fadeEnd ? 0 : 1 - (scrollY - fadeStart) / (fadeEnd - fadeStart);
  return (
    <div className={classes.megaContainer}>
      <div className={classes.videoContainer}>
        <video
          className={classes.video}
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src="images/halcyon-logo/cloud.mov"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div
          className={classes.logoContainer}
          style={{ opacity: logoOpacity }}
        >
          <HalcyonLogoContainer />
        </div>

        <img
          className={classes.imageOverlay}
          src="images/halcyon-logo/building.png"
          alt="Building Background"
          style={{
            transform: `translateY(${buildingTranslateY}%)`,
          }}
        />
      </div>
    </div>
  );
};

export default SectionOne;
